import axios from "@/libs/api.request.js";

// 埋点上报接口
export function actionTrackApi (data) {
  return axios.request({
    url: `/platform-box-user/user/event-track`,
    data,
    method: "post",
  })
}

// 获取绑定用户id
export function getBindingUserIdApi (data) {
  return axios.request({
    url: `/platform-box-game/wechat/getBindUserId`,
    data,
    method: "post",
  })
}

// 根据 gameid 获取游戏承接信息
export function getGameInfoById (data) {
  return axios.request({
    url: `/platform-box-game/wechat/getWechatGameInfo`,
    data,
    method: "post",
  })
}
